/**
 * Renders the expected passage with character-level highlighting.
 * Uses three visual states: correct (muted), incorrect (red), current (brand).
 * Un-typed characters are neutral.
 *
 * All text is rendered as plain text nodes, never as HTML.
 *
 * @param {{
 *   chars: string[],
 *   currentIndex: number,
 *   typedResults: Array<'correct' | 'incorrect' | null>,
 * }} props
 */
export function PassageDisplay({ chars, currentIndex, typedResults = [] }) {
  return (
    <div
      className="font-mono text-lg leading-relaxed tracking-wide text-text-primary sm:text-xl md:text-2xl"
      aria-label="Typing passage"
      role="textbox"
      aria-readonly="true"
      tabIndex={-1}
    >
      {chars.map((ch, i) => {
        const status = typedResults[i] || null;
        const isCurrent = i === currentIndex;
        let className = 'transition-colors duration-75';
        if (status === 'correct') {
          className += ' text-text-secondary';
        } else if (status === 'incorrect') {
          className += ' text-error underline decoration-error/60 decoration-wavy underline-offset-4';
        } else if (isCurrent) {
          className += ' bg-brand-100 text-brand-800 dark:bg-brand-900 dark:text-brand-100 rounded-sm';
        } else {
          className += ' text-text-muted';
        }
        // Render spaces visibly but without breaking layout.
        const display = ch === ' ' ? '\u00A0' : ch;
        return (
          <span key={i} className={className}>
            {display}
          </span>
        );
      })}
    </div>
  );
}